import { Checkbox } from "@narmi/design_system";
import styles from "./CompressedCheckbox.module.css";

/**
 * A checkbox that is even more compressed than the NDS "condensed" checkbox.
 * Consider moving to NDS if it ends up being enduringly useful.
 */

export function CompressedCheckbox({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  return (
    <div className={styles.compressedCheckbox}>
      <Checkbox kind="condensed" label={label} checked={checked} onChange={onChange} />
    </div>
  );
}
